import React from 'react';
import Select from 'react-select';
import { getCustomStyles } from '@/theme/components/select';
import { NoOptionsMessage } from '@/components/select';
import * as SelectComponents from '@/components/formBuilder/SelectComponents';

export const UnifiedSelectVariant = ({
  options,
  isLoading,
  hasAllDependencies,
  value,
  onChange,
  loadingText = 'Loading...',
  emptyDependencyText = 'Please fill required fields first',
  enableLocalSearch = true,
  error,
  isMulti = false,
  hasError = false,
  components: customComponents = {},
  ...props
}) => {
  const getDisplayState = () => {
    if (isLoading) {
      return {
        isDisabled: true,
        placeholder: loadingText,
        options: [],
      };
    }

    if (error) {
      return {
        isDisabled: true,
        placeholder: 'Error loading options',
        options: [],
      };
    }

    if (!hasAllDependencies) {
      return {
        isDisabled: true,
        placeholder: emptyDependencyText,
        options: [],
      };
    }

    return {
      isDisabled: false,
      placeholder:
        props.placeholder || (isMulti ? 'Select multiple...' : 'Select...'),
      options,
    };
  };

  const displayState = getDisplayState();
  const customStyles = getCustomStyles();
  
  // Resolve string component names to actual components
  const resolvedComponents = {};
  Object.entries(customComponents).forEach(([key, component]) => {
    if (typeof component === 'string' && SelectComponents[component]) {
      resolvedComponents[key] = SelectComponents[component];
    } else {
      resolvedComponents[key] = component;
    }
  });

  // Handle value conversion for both single and multi select
  const getSelectValue = () => {
    if (isMulti) {
      return Array.isArray(value)
        ? value
            .map((val) => options.find((option) => option.value === val))
            .filter(Boolean)
        : [];
    } else {
      return options.find((option) => option.value === value) || null;
    }
  };

  const handleChange = (selectedOption) => {
    if (isMulti) {
      const values = selectedOption
        ? selectedOption.map((option) => option.value)
        : [];
      onChange(values);
    } else {
      onChange(selectedOption?.value || '');
    }
  };

  return (
    <Select
      value={getSelectValue()}
      onChange={handleChange}
      isMulti={isMulti}
      isSearchable={enableLocalSearch && !displayState.isDisabled}
      styles={customStyles}
      components={{ NoOptionsMessage, ...resolvedComponents }}
      hasError={hasError}
      {...props}
      {...displayState}
    />
  );
};
